import { parsePhoneNumberFromString } from 'libphonenumber-js/max';

/** Validates the entire international number and returns E.164 without guessing a country. */
export function normalizePhoneNumber(value: unknown): string | null {
  if (typeof value !== 'string' || value.length > 100 || !value.trim().startsWith('+')) return null;
  const phone = parsePhoneNumberFromString(value.trim(), { extract: false });
  return phone?.isValid() && !phone.ext ? phone.number : null;
}
